import api from './api';
import { Airport, CreateAirportRequest, UpdateAirportRequest, AirportSearchResponse } from '../interfaces/Airport';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const airportService = {
  async findAll(): Promise<Airport[]> {
    const response = await api.get(`${API_BASE}/read/airports`);
    return response.data;
  },

  async findOne(id: number): Promise<Airport> {
    const response = await api.get(`${API_BASE}/read/airports/${id}`);
    return response.data;
  },

  async search(query: string, limit: number = 10): Promise<Airport[]> {
    const response = await api.get(`${API_BASE}/read/airports/search`, {
      params: { q: query, limit }
    });
    return response.data;
  },

  async create(data: CreateAirportRequest): Promise<Airport> {
    const response = await api.post(`${API_BASE}/write/airports`, data);
    return response.data;
  },

  async update(id: number, data: UpdateAirportRequest): Promise<Airport> {
    const response = await api.patch(`${API_BASE}/write/airports/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`${API_BASE}/write/airports/${id}`);
  }
};